import script from "./PhotographerCompetitions.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotographerCompetitions.vue?vue&type=script&setup=true&lang=js"

import "./PhotographerCompetitions.vue?vue&type=style&index=0&id=1dad3f04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dad3f04"]])

export default __exports__